const API_HOST =
  process.env.REACT_APP_ENV === "production"
    ? "https://api.quantking.net"
    : process.env.REACT_APP_ENV === "local"
    ? "http://localhost:3000"
    : "https://api-dev.quantking.net";

const BASE_URL = `${API_HOST}/api/v1/user/`;

const COMMON_URL = `${API_HOST}/api/v1/common/`;

export { BASE_URL, COMMON_URL };
